export default __webpack_public_path__ + "static/media/stumble_small.214574fc.png";